import React from 'react';
import { createPortal } from 'react-dom';
import './FullScreenImageViewer.css';

const FullScreenImageViewer = ({ imageSrc, isOpen, onClose }) => {
    if (!isOpen || !imageSrc) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return createPortal(
        <div className="fullscreen-image-overlay" onClick={handleBackdropClick}>
            <div
                className="fullscreen-image-frame"
                onClick={(event) => event.stopPropagation()}
            >
                <button
                    type="button"
                    className="fullscreen-close-button"
                    onClick={onClose}
                    aria-label="Close fullscreen view"
                >
                    ✕
                </button>
                <img
                    src={imageSrc}
                    alt="Fullscreen view"
                    className="fullscreen-image"
                />
            </div>
        </div>,
        document.body
    );
};

export default FullScreenImageViewer;
